(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/items-menu/assets/javascripts/items-menu.js') >= 0) return;  svs.modules.push('/components/ui/items-menu/assets/javascripts/items-menu.js');

'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.ui = svs.ui || {};
svs.ui.itemsMenu = svs.ui.itemsMenu || {};
svs.ui.ItemsMenu = function () {
  function ItemsMenu(options) {
    _classCallCheck(this, ItemsMenu);
    var self = this;
    this.isHover = false;
    this.log = svs.core.log.getLogger('ui:items-menu');

    if (options.items && options.items.length && options.el) {
      self.renderItems(options.el, options, function () {
        self.initItemsMenu(options, function () {
          self.setFaders();
          self.setUpScrollHelpers(self.options.useScrollFaders, self.options.useScrollHelpers, self.options.scrollIcons, self.options.showScrollbar);
          self.listenToScroll();
          self.listenToClick();
          self.setUpResizeListener();
          self.scrollToSelectedItem();
          self.listenToHover();
        });
      });
    } else {
      this.initItemsMenu(options, function () {
        self.setFaders();
        self.setUpScrollHelpers(self.options.useScrollFaders, self.options.useScrollHelpers, self.options.scrollIcons, self.options.showScrollbar);
        self.listenToScroll();
        self.listenToClick();
        self.setUpResizeListener();
        self.scrollToSelectedItem();
        self.listenToHover();
      });
    }
  }

  return _createClass(ItemsMenu, [{
    key: "initItemsMenu",
    value: function initItemsMenu(options, callback) {
      var _this = this;
      var $el = options && options.el ? options.el : undefined;
      var navEl;
      if ($el) {
        if ($el instanceof Element) {
          if ($el.classList.contains('js-items-menu-wrapper')) {
            navEl = $el;
          } else {
            navEl = $el.querySelector('.js-items-menu-wrapper');
          }
        } else if (document.querySelector(".js-items-menu-wrapper.".concat($el))) {
          navEl = document.querySelector(".js-items-menu-wrapper.".concat($el));
        } else {
          navEl = document.querySelector(".".concat($el)).querySelector(".js-items-menu-wrapper");
        }
        if (window.ResizeObserver !== undefined) {
          var resizeObserver = new ResizeObserver(function () {
            _this.setFaders();
            _this.setUpScrollHelpers(options.useScrollFaders, options.useScrollHelpers, options.scrollIcons, options.showScrollbar);
          });
          resizeObserver.observe(navEl.querySelector('.items-menu-nav'));
        }
        var menuEl = navEl.querySelector('.js-items-menu-holder');
        this.options = {
          menuEl: menuEl,
          useScrollHelpers: options && options.useScrollHelpers ? options.useScrollHelpers : false,
          useScrollFaders: options && options.useScrollFaders ? options.useScrollFaders : false,
          useScrollFadersOnHover: options && options.useScrollFadersOnHover ? options.useScrollFadersOnHover : false,
          scrollToSelected: options && options.scrollToSelectedItem ? options.scrollToSelectedItem : true,
          scrollIcons: options && options.scrollIcons ? options.scrollIcons : undefined,
          showScrollbar: options && options.showScrollbar ? options.showScrollbar : false,
          scrollWidth: navEl.querySelector('.js-items-menu-nav').scrollWidth,
          menuWidth: navEl.getBoundingClientRect().width,
          leftDimmer: navEl.querySelector('.js-items-menu-dimmer-left'),
          rightDimmer: navEl.querySelector('.js-items-menu-dimmer-right'),
          itemList: navEl.querySelectorAll('.js-items-menu-item'),
          firstItem: navEl.querySelectorAll('.js-items-menu-item')[0],
          lastItem: navEl.querySelectorAll('.js-items-menu-item')[navEl.querySelectorAll('.js-items-menu-item').length - 1],
          allowToggle: options && options.allowToggle ? options.allowToggle : false,
          clickCallback: options && options.clickCallback ? options.clickCallback : false,
          inverted: options && options.inverted ? options.inverted : false,
          branding: options && options.branding ? options.branding : false,
          items: options && options.items ? options.items : [],
          $el: options && options.el ? options.el : undefined,
          navEl: navEl,
          throttled: false,
          widestItem: undefined,
          itemsType: options && options.itemsType ? options.itemsType : 'ball_item'
        };
        callback();
      } else {
        this.log.error('No el found in options object.');
      }
    }

  }, {
    key: "renderItems",
    value: function renderItems($el, options, callback) {
      if (options.el && options.items && options.items.length > 0) {
        var items = [];
        var itemsType = options.itemsType ? options.itemsType : 'ball_item';
        for (var i = 0; i < options.items.length; i++) {
          options.items[i].itemIndex = i;
          items.push(svs.ui.items_menu.partials[itemsType](options.items[i]));
        }
        var itemsMenu = svs.ui.items_menu.partials.items_menu({
          class: options.class,
          centered: options.centered,
          branding: options.branding,
          inverted: options.inverted,
          items: items
        });
        if ($el instanceof Element) {
          $el.innerHTML = itemsMenu;
        } else {
          document.querySelector(".".concat($el)).innerHTML = itemsMenu;
        }
        callback();
      }
    }

  }, {
    key: "setUpScrollHelpers",
    value: function setUpScrollHelpers(useFaders, useScrollHelpers, scrollIcons, showScrollbar) {
      if (useFaders) {
        this.log.debug('scrollWidth: ', this.options.scrollWidth, 'menuWidth: ', this.options.menuWidth);
        if (useScrollHelpers) {
          var leftIcon = scrollIcons && scrollIcons.left ? scrollIcons.left : 'icon-menu-left';
          var rightIcon = scrollIcons && scrollIcons.right ? scrollIcons.right : 'icon-menu-right';
          this.options.leftDimmer.innerHTML = "<span class=\"items-menu-dimmer-icon items-menu-dimmer-icon-left".concat(this.options.menuEl.clientHeight < 50 ? ' items-menu-dimmer-icon-small' : '', "\">\n          <i class=\"icon icon-default icon-100 ").concat(leftIcon, "\"></i></span>");
          this.options.rightDimmer.innerHTML = "<span class=\"items-menu-dimmer-icon items-menu-dimmer-icon-right".concat(this.options.menuEl.clientHeight < 50 ? ' items-menu-dimmer-icon-small' : '', "\">\n          <i class=\"icon icon-default icon-100 ").concat(rightIcon, "\"></i></span>");
        }
      }
      if (!showScrollbar) {
        var menuWrapper = this.options.navEl;
        var scrollbarHeight = menuWrapper.clientHeight - menuWrapper.querySelector('.js-items-menu-nav').clientHeight;
        menuWrapper.style.overflow = 'hidden';
        menuWrapper.style.height = "".concat(menuWrapper.clientHeight - scrollbarHeight, "px");
      }
    }

  }, {
    key: "setFaders",
    value: function setFaders() {
      if (this.options.useScrollFaders) {
        if (!this.options.firstItem.classList.contains('items-menu-link-item-absolute')) {
          this.options.menuEl.webkitOverflowScrolling = 'unset';
          if (this.options.menuEl.scrollLeft < this.options.firstItem.clientWidth / 4) {
            this.options.leftDimmer.style.transition = 'transform ease-in-out 400ms';
            this.options.leftDimmer.style.transform = 'scaleX(0)';
          } else {
            if (!this.options.useScrollFadersOnHover || this.isHover && this.options.useScrollFadersOnHover) {
              this.options.leftDimmer.style.transition = 'transform ease-in-out 400ms';
              this.options.leftDimmer.style.transform = 'scaleX(1)';
            }
          }
        }
        if (this.options.menuEl.scrollLeft + this.options.menuEl.clientWidth >= this.options.menuEl.scrollWidth - this.options.lastItem.clientWidth / 4) {
          this.options.rightDimmer.style.transform = 'scaleX(0)';
        } else {
          if (!this.options.useScrollFadersOnHover || this.options.useScrollFadersOnHover && this.isHover) {
            this.options.rightDimmer.style.transform = 'scaleX(1)';
          }
        }
      }
      if (!this.options.firstItem.classList.contains('items-menu-link-item-absolute')) {
        this.options.menuEl.classList.add('items-menu-overflow-touch');
      }
    }

  }, {
    key: "listenToScroll",
    value: function listenToScroll() {
      var self = this;
      this.options.menuEl.addEventListener('scroll', function () {
        self.setFaders();
      });
    }
  }, {
    key: "listenToHover",
    value: function listenToHover() {
      var _this2 = this;
      if (this.options.useScrollFadersOnHover) {
        this.options.navEl.addEventListener('mouseenter', function () {
          _this2.isHover = true;
          _this2.setFaders();
        });
        this.options.navEl.addEventListener('mouseleave', function () {
          _this2.isHover = false;
          _this2.setFaders();
        });
      }
    }

  }, {
    key: "listenToClick",
    value: function listenToClick() {
      var _this3 = this;
      var self = this;
      if (!this.options.widestItem) {
        var items = this.options.itemList;
        for (var i = 0; i < items.length; i++) {
          this.options.widestItem = this.options.widestItem ? items[i].clientWidth > this.options.widestItem ? items[i].clientWidth : this.options.widestItem : items[i].clientWidth;
        }
      }
      var scrollBy = this.options.widestItem ? this.options.widestItem + 42 : 100; 

      this.options.leftDimmer.addEventListener('click', function (e) {
        e.preventDefault();
        if (self.options.menuEl.scrollBy === undefined) {
          var scrollLeft = self.options.menuEl.scrollLeft + scrollBy;
          self.options.menuEl.scrollLeft = -scrollLeft;
        } else {
          self.options.menuEl.scrollBy({
            top: 0,
            left: -scrollBy,
            behavior: 'smooth'
          });
        }
        return false;
      });
      this.options.rightDimmer.addEventListener('click', function (e) {
        e.preventDefault();
        if (self.options.menuEl.scrollBy === undefined) {
          var scrollLeft = self.options.menuEl.scrollLeft + scrollBy;
          self.options.menuEl.scrollLeft = scrollLeft;
        } else {
          self.options.menuEl.scrollBy({
            top: 0,
            left: scrollBy,
            behavior: 'smooth'
          });
        }
        return false;
      });

      for (var _i = 0; _i < this.options.itemList.length; _i++) {
        this.options.itemList[_i].addEventListener('click', function (e) {
          var evt = e;

          if (!self.options.throttled) {
            self.options.throttled = true;
            if (!evt.currentTarget.classList.contains('items-menu-active')) {
              var selectedItems = evt.currentTarget.parentElement.getElementsByClassName('items-menu-active');
              for (var _i2 = 0; _i2 < selectedItems.length; _i2++) {
                selectedItems[_i2].ariaSelected = 'false';
                selectedItems[_i2].classList.remove('items-menu-active');
              }
              evt.currentTarget.ariaSelected = 'true';
              evt.currentTarget.classList.add('items-menu-active');
            } else if (self.options.allowToggle && evt.currentTarget.classList.contains('items-menu-active')) {
              evt.currentTarget.ariaSelected = 'false';
              evt.currentTarget.classList.remove('items-menu-active');
            }
            if (evt.currentTarget.dataset && evt.currentTarget.dataset.index && self.options.items[parseInt(evt.currentTarget.dataset.index, 10)] && self.options.items[evt.currentTarget.dataset.index].clickCallback) {
              evt.stopImmediatePropagation();
              self.options.items[evt.currentTarget.dataset.index].clickCallback(self.getItemAttributes(evt), evt);
            }

            if (self.options.clickCallback) {
              evt.stopImmediatePropagation();
              self.options.clickCallback(self.getItemAttributes(evt), evt);
            }
            if (self.options.scrollToSelected) {
              _this3.scrollToSelectedItem();
            }
            self.options.throttled = false;
          }
        });
      }
    }

  }, {
    key: "getItemAttributes",
    value: function getItemAttributes(evt) {
      evt.preventDefault();
      var item = {};
      var attributes = evt.currentTarget.attributes;
      for (var i = 0; i < attributes.length; i++) {
        item[attributes[i].name] = attributes[i].value;
      }
      return item;
    }

  }, {
    key: "setUpResizeListener",
    value: function setUpResizeListener() {
      var self = this;
      window.addEventListener('resize', function () {
        if (!self.options.throttled) {
          self.setFaders();
          self.options.throttled = true;

          setTimeout(function () {
            self.options.throttled = false;
          }, 250);
        }
      });
    }

  }, {
    key: "scrollToSelectedItem",
    value: function scrollToSelectedItem() {
      if (this.options.scrollToSelected) {
        var activeEl = this.options.navEl.querySelector('.items-menu-active');
        if (activeEl && this.isNotInView(activeEl) && this.options.menuEl.scrollBy) {
          var activePos = activeEl.offsetLeft + activeEl.clientWidth + 12 + (this.options.useScrollFaders ? this.options.rightDimmer.clientWidth : 0) - this.options.menuEl.clientWidth;
          this.options.menuEl.scrollBy({
            top: 0,
            left: activePos,
            behavior: 'smooth'
          });
        }
      }
    }

  }, {
    key: "isNotInView",
    value: function isNotInView(element) {
      var rect = element.getBoundingClientRect();
      var wrapperRect = this.options.navEl.getBoundingClientRect();
      var scrollAreaWidth = this.options.navEl.querySelector('.js-items-menu-holder').clientWidth;
      return rect.right >= scrollAreaWidth || rect.left <= wrapperRect.left;
    }

  }, {
    key: "setSelectedItemByIndex",
    value: function setSelectedItemByIndex(index, scrollToSelected) {
      var items = this.options.navEl.querySelectorAll('.js-items-menu-item');
      for (var i = 0; i < items.length; i++) {
        if (index === i) {
          items[i].classList.add('items-menu-active');
        } else {
          items[i].classList.remove('items-menu-active');
        }
      }

      if (scrollToSelected) {
        this.scrollToSelectedItem();
      }
    }
  }]);
}();

 })(window);